// extracted by mini-css-extract-plugin
module.exports = {"NewMessageModal":"NewMessageModal_NewMessageModal__1ccdx"};